
<div class="absolute inset-0 lg:w-full lg:h-full">
  <swiper
    v-if="images && images.length > 0"
    :options="swiperOptions"
    class="h-full"
  >
    <swiper-slide v-for="(item, index) in images" :key="index">
      <figure
        class="image-caption-wrapper h-full"
        :class="
          swiperBackgroundColour ? `bg-${swiperBackgroundColour}` : 'bg-white'
        "
      >
        <img
          class="w-full h-full object-cover"
          :src="item.url"
          :alt="item.title || item.text"
        />

        <figcaption
          v-if="item.text"
          class="image-caption pb-6 lg:pb-8"
          v-html="item.text"
        ></figcaption>
      </figure>
    </swiper-slide>
    <div slot="pagination" class="swiper-pagination"></div>
  </swiper>
</div>
